import { useEffect, useState } from 'react';
import ButtonLink from './ButtonLink';
import { useResizeObserver } from '../hooks/useResizeObserver';

import { useTranslation } from 'react-i18next';
import '../utils/i18next';

interface propsMoreControls {
	handlerRef: any;
	openedItems: any;
	handleOpenedItems: any;
	items: any;
	handleBlockHeight: any;
}

function MoreControls({
	handlerRef,
	openedItems,
	handleOpenedItems,
	items,
	handleBlockHeight,
}: propsMoreControls) {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const { t } = useTranslation();

	const [dimensions, setDimensions] = useState({ top: 0, left: 0 });
	const optionalCallback = (entry: DOMRectReadOnly) =>
		setDimensions({ top: entry.x, left: entry.left });
	const [width, height] = useResizeObserver(handlerRef, optionalCallback);

	const handleOnClickMore = () => {
		if (openedItems) {
			if (openedItems?.length + 4 < items.length) {
				handleOpenedItems(items.slice(0, openedItems?.length + 4));
			} else {
				handleOpenedItems(items);
			}

			if (!isOpen) {
				setIsOpen(true);
			}
		}
	};

	const handleOnClickClose = () => {
		handleOpenedItems(items.length >= 4 ? items.slice(0, 4) : items);
		setIsOpen(false);
	};

	useEffect(() => {
		handleBlockHeight(height);
	}, [height]);

	return (
		<div className="about-file__controlls">
			{openedItems?.length !== items.length && (
				<ButtonLink
					className="about-file__controll"
					color="blue"
					type="button"
					onClick={handleOnClickMore}
				>
					{t('about.buttons.see-more')}
				</ButtonLink>
			)}
			<ButtonLink
				className="about-file__controll"
				color="blue"
				type="button"
				onClick={handleOnClickClose}
			>
				{isOpen && t('about.buttons.close-more')}
			</ButtonLink>
		</div>
	);
}

export default MoreControls;
